export const REQUEST_TYPES = [
    { value: 'ONBOARDING', label: 'Onboarding' },
    { value: 'DEACTIVATION', label: 'Deactivation' },
    { value: 'REACTIVATION', label: 'Reactivation' },
];

export const REQUEST_STATUSES = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'REJECTED', label: 'Rejected' },
    { value: 'APPROVED', label: 'Approved' },
];

export const ADDITION_TYPES = [
    { value: 'NEW_ADDITION', label: 'New Addition' },
    { value: 'REPLACEMENT', label: 'Replacement' },
];

/** A separation's Source is always SINGLE and tells an approver nothing; the reason it was raised
 * for is what they are actually deciding on, so it takes that column's place. */
export const approvalColumnsFor = (requestType: string) =>
    requestType === 'ONBOARDING'
        ? APPROVAL_TABLE_COLUMNS
        : [
              { key: 'requestRef', label: 'Request ID', width: 10 },
              { key: 'riderName', label: 'Rider', width: 10 },
              { key: 'contactNumber', label: 'Phone', width: 8 },
              { key: 'orgName', label: 'Vendor', width: 10 },
              { key: 'storeId', label: 'Store', width: 7 },
              { key: 'zone', label: 'Zone', width: 5 },
              { key: 'employeeMode', label: 'Emp Mode', width: 6 },
              { key: 'reason', label: 'Reason', width: 10 },
              { key: 'lastWorkingDate', label: 'Last Working Day', width: 8 },
              { key: 'createdAt', label: 'Raised On', width: 8 },
              { key: 'lastAction', label: 'Last Action', width: 9 },
              { key: 'actions', label: '', width: 9 },
          ];

export const APPROVAL_TABLE_COLUMNS = [
    { key: 'requestRef', label: 'Request ID', width: 13 },
    { key: 'riderName', label: 'Rider', width: 13 },
    { key: 'contactNumber', label: 'Phone', width: 9 },
    { key: 'orgName', label: 'Vendor', width: 12 },
    { key: 'storeId', label: 'Store', width: 8 },
    { key: 'zone', label: 'Zone', width: 6 },
    { key: 'employeeMode', label: 'Emp Mode', width: 7 },
    { key: 'source', label: 'Source', width: 6 },
    { key: 'createdAt', label: 'Raised On', width: 9 },
    { key: 'lastAction', label: 'Last Action', width: 9 },
    { key: 'actions', label: '', width: 8 },
];

/** The submission is stored as JSON, so rider details are read out of it rather than being
 * mirrored into columns nothing queries on. */
export const parsePayload = (payload?: string | null): any => {
    if (!payload) return {};
    try {
        return JSON.parse(payload);
    } catch {
        return {};
    }
};

/** A separation carries no payload, so its name comes off the request itself; an onboarding that
 * has not been approved yet has no rider row, so its name comes out of the payload. */
/** Description when the server resolved one, else the raw code so the cell is never blank. */
export const reasonOf = (row: any): string =>
    row?.reasonDescription || row?.reasonCode || '-';

/** Whether this request's reason is one of those that bars the rider from ever coming back. */
export const barsRejoining = (row: any): boolean =>
    row?.rehireEligible === 'NO';

/** The reason as an approver should read it, with the consequence spelled out. */
export const reasonWithEligibilityOf = (row: any): string =>
    barsRejoining(row)
        ? `${reasonOf(row)} — Not eligible for rejoining`
        : reasonOf(row);

/** The rider's final day, as a person reads it. Blank until one was captured. */
export const lastWorkingDateOf = (row: any): string =>
    row?.lastWorkingDate
        ? new Date(row.lastWorkingDate).toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
          })
        : '-';

export const riderNameOf = (row: any): string =>
    row?.riderName || parsePayload(row?.payload)?.name || '-';

/** Server resolves it from the payload or the rider's settings; the payload is the fallback for
 * rows written before it was returned. */
export const employeeModeOf = (row: any): string =>
    row?.employeeMode || parsePayload(row?.payload)?.employeeMode || '-';
